import "./surveys.css";
import { Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useMutation, useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import Spinner from "@src/components/spinner";
import { setNotification } from "@src/middleware/redux/reducers/notification.reducer";
import { getMySurveyQuery } from "@src/util/query/survey.query";
import { submitMySurveyMutation } from "@src/util/mutation/survey.mutation";
import { SurveyAnswerForm } from "./surveyAnswerForm";
import { onForm, SurveyFormFill } from "../formOnPdf/formOnPdf";

/** A logged-in employee answering one of their surveys on the web (My surveys). */
export const MySurveyModal = ({ responseId, onClose, onAnswered = () => {} }) => {
    const dispatch = useDispatch();
    const { data, loading } = useQuery(getMySurveyQuery, { variables: { responseId }, skip: !responseId, fetchPolicy: "network-only" });
    const [submit, { loading: submitting }] = useMutation(submitMySurveyMutation);
    const form = data?.getMySurvey?.response;

    const send = async (answers, signed) => {
        try {
            const res = await submit({ variables: { responseId, answers, ...(signed || {}) } });
            dispatch(setNotification({ error: false, notificationState: true, message: res?.data?.submitMySurvey?.message || "Thank you" }));
            onAnswered();
            onClose();
        } catch (err) {
            dispatch(setNotification({ error: true, notificationState: true, message: err.message }));
        }
    };

    return (
        <Modal open={!!responseId} width={onForm(form) ? 960 : 700} closable={false} onCancel={onClose} footer={null}>
            <div className="modal-header-title">
                <span style={{ letterSpacing: "0.2px" }}>{form?.title || "Survey"}</span>
                <span onClick={onClose}><FontAwesomeIcon className="close" icon={faClose} /></span>
            </div>
            <div className="modal-body" style={{ margin: "16px 0 0", maxHeight: "70vh", overflowY: "auto" }}>
                {loading || !form ? <Spinner /> : form.state === "submitted" ? (
                    <div className="svy-state"><div className="svy-state-title">You've answered this survey</div><div className="svy-state-text">Thank you.</div></div>
                ) : form.state === "closed" ? (
                    <div className="svy-state"><div className="svy-state-title">This survey has closed</div></div>
                ) : (
                    <>
                        <div className="svy-hint" style={{ marginBottom: 14 }}>Please answer by {dayjs(form.closesOn).format("D MMMM YYYY")}.</div>
                        {onForm(form) ? <SurveyFormFill form={form} submitting={submitting} onSubmit={send} /> : <SurveyAnswerForm form={form} submitting={submitting} onSubmit={send} />}
                    </>
                )}
            </div>
        </Modal>
    );
};
